import { render } from "./DateControl.vue?vue&type=template&id=6be12115&scoped=true"
import script from "./DateControl.vue?vue&type=script&lang=js"
export * from "./DateControl.vue?vue&type=script&lang=js"

import "./DateControl.vue?vue&type=style&index=0&id=6be12115&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be12115"]])

export default __exports__